import React from "react";
import { Link } from 'react-router-dom';

export default function Analytics() {
  return (
    <section className="relative ">
      <div className="relative z-10 grid grid-cols-1 gap-4 xl-custom:grid-cols-12 mx-auto max-w-6xl px-4 p-14 sm:px-6">

        <div className="w-full flex justify-center order-1 xl-custom:order-1 col-span-1 xl-custom:col-span-6">
          <img
            src="/uploads/Assets/Analytics_image.webp"
            alt="asset1"
            className="w-full h-auto object-contain"
          />
        </div>

        <div className="w-full py-8 text-black text-left order-2 xl-custom:order-2 col-span-1 xl-custom:col-start-8 xl-custom:col-span-5 xl-custom:pl-12">
          <div className="flex flex-col space-y-2">
            <h2 className="font-uber text-[28px] font-bold leading-[36px] sm:text-[32px] sm:leading-[40px] xl-custom:text-[36px] xl-custom:leading-[44px]">Analytics</h2>
            <p className="text-current font-uber text-[16px] font-normal leading-[24px]">
              Unlock actionable insights with real-time data on user engagement, completion rates, and conversions.
            </p>
          </div>

          <Link to="/analytics">
            <button className="mt-4 xl-custom:mt-8 px-6 py-2 bg-black text-white rounded active:bg-gray-700 active:text-white text-[16px] font-uber font-medium">
              Learn More
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
}